import React from 'react';
import { Box, Tooltip } from '@mui/material';

// Text that explains itself on hover. The dotted underline marks it as such;
// tabIndex lets a keyboard user reach the same tooltip.
const Help: React.FC<{ title?: string; children: React.ReactNode }> = ({ title, children }) =>
  title ? (
    <Tooltip title={title} arrow placement="top" enterDelay={200}>
      <Box
        component="span"
        tabIndex={0}
        sx={{
          textDecoration: 'underline dotted',
          textUnderlineOffset: '3px',
          cursor: 'help',
        }}
      >
        {children}
      </Box>
    </Tooltip>
  ) : (
    <>{children}</>
  );

export default Help;
